import { render, staticRenderFns } from "./global-footer.vue?vue&type=template&id=d21a1b2a&scoped=true&"
import script from "./global-footer.vue?vue&type=script&lang=js&"
export * from "./global-footer.vue?vue&type=script&lang=js&"
import style0 from "./global-footer.vue?vue&type=style&index=0&id=d21a1b2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d21a1b2a",
  null
  
)

export default component.exports